var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"value":_vm.showError,"color":"red","type":"error"}},[_vm._v(" "+_vm._s(`${_vm.filename} does not contain any location data`)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }